import 'rc-slider/assets/index.css';

import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

import { AvatarContext, Button, ButtonIcon, Footer, Page, PageContainer } from '@sonyged/ext-proc';

import Constants from './Constants';
import ImageSelection from './ImageSelection';

export default class WagonSettingContent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={'proc-ice-field-content initial-setting'}>
        <Page.normal>
          <PageContainer.normal className={'flex flex-column'}>
            <div className="proc-contents">
              <div className={'title-container'}>
                <div className={'title proc-huge-font gray100-color center-aligned'}>すきな ワゴンを えらぼう</div>
              </div>
              <div className="secondary60-border-color proc-border secondary30-border-bottom-color" />
              {this._renderContent()}
            </div>
          </PageContainer.normal>
        </Page.normal>
        {this._renderFooter()}
      </div>
    );
  }

  _renderContent() {
    return (
      <div className={`content initial-setting`}>
        <div className={'wagon-image-container relative'}>
          <img src={Constants.getWagonIcon2(this.props.wagon)} className={'image'} />
          <AvatarContext.Consumer>
            {avatar => {
              return <img className="avatar-image" src={Constants.getWagonAvatarImage(avatar ? avatar : 1)} />;
            }}
          </AvatarContext.Consumer>
        </div>
        <ImageSelection
          value={this.props.wagon}
          images={Constants.getWagonIcons()}
          labels={['', '', '']}
          className={'white'}
          onSelected={this.props.onWagonChange}
        />
      </div>
    );
  }

  _renderFooter() {
    return (
      <Footer.nav
        shadow={false}
        navItem={
          <Link to={{ pathname: '/ice/fields', search: '?skip_intro=true' }}>
            {this.props.research ? (
              <Button.normal>
                <ButtonIcon.back />
              </Button.normal>
            ) : (
              <Button.light>
                <ButtonIcon.back />
              </Button.light>
            )}
          </Link>
        }
      >
        <Button.attention onClick={this.props.onNextClick}>つぎへ</Button.attention>
      </Footer.nav>
    );
  }
}

WagonSettingContent.propTypes = {
  wagon: PropTypes.number,
  onNextClick: PropTypes.func,
  onWagonChange: PropTypes.func,
  title: PropTypes.string,
  research: PropTypes.bool,
};

WagonSettingContent.defaultProps = {};
